import React, { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import { Navigate, useLocation, useNavigate } from "react-router-dom";



import MobileBackButton from "../../../components/mobile/MobileBackButton";
import { useAuthStore } from "../../../store/authStore";
import { useLoaderStore } from "../../../store/loaderStore";
import { reverseGeocode } from "../../../utils/googleMaps";
import { api } from "../../../utils/api";
import { canMobilePunch, MOBILE_PUNCH_DENIED_MESSAGE } from "../../../utils/mobilePunchAccess";


import { toast } from "react-toastify";

import "./Punchmark.css";





export default function PunchMark() {
    const navigate = useNavigate();
    const webcamRef = useRef(null);

    // page the punch was started from (bottom nav), else the dashboard
    const { state: routeState } = useLocation();
    const returnTo = routeState?.from || "/admin/mobile/dashboard";

    const { user } = useAuthStore();
    const mobilePunchAllowed = canMobilePunch(user);

    

    const [capturedImage, setCapturedImage] = useState(null);
    const [location, setLocation] = useState(null);
    const [locationName, setLocationName] = useState("");
    const [locationError, setLocationError] = useState("");

    useEffect(() => {
        if (!location) return;

        let active = true;
        setLocationName("");
        reverseGeocode(location.latitude, location.longitude)
            .then((geoResult) => {
                if (active) {
                    setLocationName(geoResult?.shortAddress || "Address unavailable for this location.");
                }
            })
            .catch((error) => {
                console.error("Location address lookup failed:", error);
                if (active) {
                    setLocationName("Location captured. Address unavailable.");
                }
            });

        return () => { active = false; };
    }, [location]);

    const { showLoader, hideLoader } = useLoaderStore();




    const handleCapture = () => {
        if (!mobilePunchAllowed) {
            toast.info(MOBILE_PUNCH_DENIED_MESSAGE);
            return;
        }
        const imageSrc = webcamRef.current?.getScreenshot();

        if (!imageSrc) return;

        showLoader("mobile");
        setLocationError("");

        const showResultScreen = () => {
            
                setCapturedImage(imageSrc);
                hideLoader(false);
            
        };

        if (!navigator.geolocation) {
            setLocationError("Location is not supported by this browser.");
            showResultScreen();
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => {
                console.log("Location fetched");

                setLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });

                showResultScreen();
            },

            (error) => {
                console.error(
                    "Location access failed:",
                    error
                );

                setLocationError(
                    error.code === 1
                        ? "Location access denied. Allow location access in your browser."
                        : "Unable to capture location. Check your device location settings."
                );
                showResultScreen();
            },

            {
                enableHighAccuracy: true,
                timeout: 10000,
                maximumAge: 0,
            }
        );
    };


   const handleConfirm = async () => {
    if (!mobilePunchAllowed) {
        toast.info(MOBILE_PUNCH_DENIED_MESSAGE);
        return;
    }
    try {
        showLoader("mobile");

        const formData = new FormData();

        formData.append(
            "company_id",
            user?.company_id
        );

        formData.append(
            "user_id",
            user?.user_id
        );

        formData.append(
            "employee_code",
            user?.employee_code
        );

        formData.append(
            "latitude",
            location?.latitude || 0
        );

        formData.append(
            "longitude",
            location?.longitude || 0
        );

        formData.append(
            "device_info",
            "Mobile"
        );

        // Convert captured base64 image to Blob
        if (capturedImage) {
            const imageBlob = await fetch(capturedImage).then(
                (res) => res.blob()
            );

            formData.append(
                "image_file",
                imageBlob,
                "punch.jpg"
            );
        }

        console.log("Punch FormData:", formData);

        const response = await api.upload(
            "/attendance/mobile-punch",
            formData
        );

        const result = await response.json();

        console.log("Punch Response:", result);

        if (!result.status) {
            throw new Error(
                result.message || "Punch failed"
            );
        }

        toast.success(
            result.message ||
            "Attendance marked successfully"
        );

        navigate(returnTo, { replace: true });

    } catch (error) {
        console.error("Punch error:", error);

        toast.error(
            error.message ||
            "Unable to mark attendance"
        );
    } finally {
        hideLoader();
    }
};

    const employeeName = `${user?.first_name || ""} ${user?.last_name || ""
        }`.trim();

    const employeeRole =
        user?.designation || "Employee";

    const employeeId =
        user?.employee_code || "-";

    const currentDate = new Date().toLocaleDateString();

    const currentTime = new Date().toLocaleTimeString(
        [],
        {
            hour: "2-digit",
            minute: "2-digit",
        }
    );

    const mapUrl = location
        ? `https://maps.google.com/maps?q=${location.latitude},${location.longitude}&z=15&output=embed`
        : null;

    if (!mobilePunchAllowed) {
        return <Navigate to="/admin/mobile/dashboard" replace />;
    }

    return (


        <div className="capture-layout">


            <div className="capture-page">
                {/* CAMERA SCREEN */}
                {!capturedImage &&  (
                    <>

                        <MobileBackButton
                            className="admin-back-btn"
                            onClick={() => navigate(returnTo)}
                        />

                        <Webcam
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            audio={false}
                            videoConstraints={{
                                facingMode: "user",
                            }}
                            className="camera-preview"
                        />

                        <div className="capture-footer">
                            <button
                                className="capture-btn"
                                onClick={handleCapture}
                            />
                        </div>
                    </>
                )}
                {capturedImage &&  (
                    <div className="result-screen">
                        <MobileBackButton
                            className="admin-back-btn"
                            onClick={() => navigate(returnTo)}
                        />

                        {/* EMPLOYEE CARD */}
                        <div className="employee-card">

                            <h2 className="employee-result-name">
                                {employeeName}
                            </h2>

                            <p className="employee-result-role">
                                {employeeRole}
                            </p>

                            <img
                                src={capturedImage}
                                alt="Captured"
                                className="Adminresult-photo"
                            />

                            <div className="result-details">

                                <table className="result-table">

                                    <tbody>
                                        <tr>
                                            <td>Employee ID</td>
                                            <td>:</td>
                                            <td>{employeeId}</td>
                                        </tr>

                                        <tr>
                                            <td>Date</td>
                                            <td>:</td>
                                            <td>{currentDate}</td>
                                        </tr>

                                        <tr>
                                            <td>Entry Time</td>
                                            <td>:</td>
                                            <td>{currentTime}</td>
                                        </tr>
                                    </tbody>

                                </table>

                            </div>

                        </div>

                        {/* LOCATION CARD */}
                        <div className="location-card">

                            {location ? (
                                <>
                                    <p className="location-text">
                                        {locationName || "Finding location address..."}
                                        <br />
                                        <span>
                                            (Lat: {location.latitude.toFixed(6)}, Lng: {location.longitude.toFixed(6)})
                                        </span>
                                    </p>

                                    {/* <p className="office-name">
                                        {user?.location_name || "Office Location"}
                                    </p> */}

                                    <iframe
                                        title="Location Map"
                                        src={mapUrl}
                                        className="map-frame"
                                        loading="lazy"
                                    />
                                </>
                            ) : (
                                <p role="status">{locationError || "Fetching location..."}</p>
                            )}

                            <button
                                className="confirm-btn"
                                onClick={handleConfirm}
                            >
                                Confirm Details
                            </button>

                        </div>
                    </div>
                )}

                
            </div>
        </div>



    );
}
